import { useEffect, useState, useMemo } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useActiveInactiveCompanies = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();

    const [inactiveCompaniesRaw, setInactiveCompaniesRaw] = useState([]);
    const [activeCompanies, setActiveCompanies] = useState([]);

    useEffect(() => {
        const fetchActiveCompanies = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard.demandEligibility;
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies });

            try {
                const response = await getData(`${baseUrl}?${query}`);
                if (response?.success) {
                    setActiveCompanies([
                        ...(response.data.subscribedCompaniesWithRecentCases || []),
                        ...(response.data.aLaCarteCompaniesWithRecentCases || [])
                    ]);
                    setInactiveCompaniesRaw(response.data.inactiveCompaniesWithMostRecentCaseData);
                }
            } catch (err) {
                console.error("Failed to fetch active companies", err);
                setInactiveCompaniesRaw([]);
                setActiveCompanies([]);
            }
        };

        fetchActiveCompanies();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    const inactiveCompanies = useMemo(() => {
        return inactiveCompaniesRaw
    }, [inactiveCompaniesRaw]);

    const pieData = useMemo(() => {
        if (!activeCompanies?.length) return [];

        const allCasesSum = activeCompanies.reduce(
            (sum, company) => sum + (company.totalCases || 0),
            0
        );
        return activeCompanies.map(company => ({
            name: company.companyName,
            count: company.totalCases || 0,
            percentage: allCasesSum
                ? Number(((company.totalCases || 0) / allCasesSum * 100).toFixed(2))
                : 0
        }))
            .sort((a, b) => b.count - a.count);
    }, [activeCompanies]);

    return {
        isLoading,
        activeCompanies,
        inactiveCompanies,
        pieData
    };
};
